import type { Fallacy } from "./types";
import { createStory } from "./types";

export const cherryPicking: Fallacy = {
    id: "cherry-picking",
    name: "Cherry Picking",
    emoji: "🍒",
    category: "Argumen Lemah",
    description:
      "Hanya **memilih data yang mendukung** argumen sambil **mengabaikan yang bertentangan**.",
    tldr: "Datanya dipilih-pilih yang cocok doang? Mana data lengkapnya?",
    detail:
      "Cherry Picking adalah kesalahan logika di mana seseorang hanya **memilih data yang mendukung** argumennya, sambil sengaja **mengabaikan bukti yang bertentangan**. Datanya memang benar — hanya saja tidak lengkap.\n\nKenapa berbahaya? Karena **data setengah-setengah lebih menyesatkan** daripada tidak ada data sama sekali. Orang merasa yakin karena ada 'bukti', padahal buktinya sudah dikurasi.\n\nCara mengenali: Apakah ini gambaran lengkapnya? Apakah ada data yang sengaja tidak ditampilkan?",
    story: createStory("Cherry Picking", "🍒", {
      hook: {
        title: "Datanya ada. Buktinya juga ada.",
        body: "Tapi yang ditampilin cuma yang cocok sama narasi. Yang gak cocok? Disembunyiin.",
      },
      convo: {
        claim: "Strategi investasi aku emang jitu. **Saham A naik 40%, saham B naik 25%!** Buktinya cuan semua. Aku emang jago milih saham.",
        response: "Saham C, D, E yang minus gak diceritain. **Yang ditampilin cuma yang cuan.**",
      },
      reveal: {
        body: "Datanya **dipilih-pilih** yang mendukung doang. Yang bertentangan? **Sengaja diabaikan**. Datanya bener, tapi gak lengkap.",
      },
      insight: {
        title: "Kenapa berbahaya?",
        body: "**Data setengah-setengah lebih menyesatkan** daripada gak ada data sama sekali. Kamu ngerasa yakin karena ada \"bukti\" — padahal buktinya udah dipilihin.",
      },
      engagement: {
        title: "Paling sering nemu cherry picking di mana?",
        body: "Presentasi kantor atau postingan flexing? **Share pengalaman kamu di komen!** 👇",
      },
    }),
    related: ["hasty-generalization", "red-herring", "appeal-to-authority"],
  };
